<template>
  <div ref="root" class="multiEventoSelector" :class="{ aberto }">
    <button
      v-if="!aberto"
      type="button"
      class="multiEventoSelectorValor"
      :title="eventoSelecionado ? eventoSelecionado.nome : placeholder"
      @click="abrir"
    >
      <i class="fa fa-television" aria-hidden="true"></i>
      <span>{{ eventoSelecionado ? eventoSelecionado.nome : placeholder }}</span>
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </button>

    <div v-else class="multiEventoSelectorBusca">
      <i class="fa fa-search" aria-hidden="true"></i>
      <input
        ref="input"
        v-model.trim="busca"
        type="search"
        autocomplete="off"
        placeholder="Buscar evento"
        role="combobox"
        aria-label="Buscar evento"
        :aria-expanded="aberto ? 'true' : 'false'"
        @keydown.down.prevent="mover(1)"
        @keydown.up.prevent="mover(-1)"
        @keydown.enter.prevent="selecionarAtivo"
        @keydown.esc.prevent="fechar"
      />
      <button type="button" title="Fechar" aria-label="Fechar busca" @click="fechar">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div v-if="aberto" class="multiEventoSelectorLista" role="listbox">
      <button
        v-for="(evento, indice) in eventosVisiveis"
        :key="evento.id"
        type="button"
        role="option"
        :class="{ ativo: indiceAtivo === indice, selecionado: evento.id === value }"
        :aria-selected="evento.id === value ? 'true' : 'false'"
        @mouseenter="indiceAtivo = indice"
        @mousedown.prevent="selecionar(evento.id)"
      >
        <i
          class="fa"
          :class="evento.id === value ? 'fa-check-circle' : 'fa-play-circle-o'"
          aria-hidden="true"
        ></i>
        <span>
          <strong>{{ evento.nome }}</strong>
          <small v-if="evento.competicao">{{ evento.competicao }}</small>
        </span>
      </button>
      <p v-if="!eventosVisiveis.length">Nenhum evento encontrado</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiEventoSelector",
  props: {
    eventos: { type: Array, default: () => [] },
    placeholder: { type: String, default: "Selecionar evento" },
    value: { type: String, default: "" },
  },
  data() {
    return {
      aberto: false,
      busca: "",
      indiceAtivo: 0,
    };
  },
  computed: {
    eventoSelecionado() {
      return this.eventos.find((evento) => evento.id === this.value) || null;
    },
    eventosVisiveis() {
      const busca = this.normalizar(this.busca);
      const eventos = busca
        ? this.eventos.filter((evento) =>
            this.normalizar(
              (evento.nome || "") + " " + (evento.competicao || "")
            ).includes(busca)
          )
        : this.eventos;
      return eventos.slice(0, 100);
    },
  },
  watch: {
    busca() {
      this.indiceAtivo = 0;
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.cliqueExterno);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.cliqueExterno);
  },
  methods: {
    abrir() {
      this.aberto = true;
      this.busca = "";
      this.indiceAtivo = Math.max(
        0,
        this.eventosVisiveis.findIndex((evento) => evento.id === this.value)
      );
      this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
    },
    fechar() {
      this.aberto = false;
      this.busca = "";
    },
    cliqueExterno(evento) {
      if (
        this.aberto &&
        this.$refs.root &&
        !this.$refs.root.contains(evento.target)
      ) {
        this.fechar();
      }
    },
    mover(direcao) {
      if (!this.eventosVisiveis.length) {
        return;
      }
      this.indiceAtivo =
        (this.indiceAtivo + direcao + this.eventosVisiveis.length) %
        this.eventosVisiveis.length;
    },
    normalizar(valor) {
      return (valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("pt-BR");
    },
    selecionar(eventoId) {
      this.$emit("input", eventoId);
      this.$emit("change", eventoId);
      this.fechar();
    },
    selecionarAtivo() {
      const evento = this.eventosVisiveis[this.indiceAtivo];
      if (evento) {
        this.selecionar(evento.id);
      }
    },
  },
};
</script>

<style scoped>
.multiEventoSelector {
  height: 36px;
  min-width: 0;
  position: relative;
  width: 100%;
}

.multiEventoSelectorValor,
.multiEventoSelectorBusca {
  align-items: center;
  background: #20292e;
  border: 1px solid #46545c;
  color: #e7edef;
  display: grid;
  gap: 8px;
  grid-template-columns: 16px minmax(0, 1fr) 14px;
  height: 36px;
  padding: 0 10px;
  text-align: left;
  width: 100%;
}

.multiEventoSelectorValor > i:first-child,
.multiEventoSelectorBusca > i {
  color: #42bd89;
}

.multiEventoSelectorValor > i:last-child {
  color: #9ca8ae;
  font-size: 10px;
}

.multiEventoSelectorValor span {
  font-size: 11px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multiEventoSelectorBusca {
  grid-template-columns: 16px minmax(0, 1fr) 28px;
}

.multiEventoSelectorBusca input {
  background: transparent;
  border: 0;
  color: #ffffff;
  font-size: 11px;
  height: 100%;
  min-width: 0;
  outline: 0;
}

.multiEventoSelectorBusca button {
  background: transparent;
  border: 0;
  color: #b7c0c5;
  height: 30px;
  padding: 0;
}

.multiEventoSelectorLista {
  background: #182025;
  border: 1px solid #536169;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.48);
  left: 0;
  max-height: min(330px, calc(100vh - 110px));
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: 39px;
  z-index: 1200;
}

.multiEventoSelectorLista button {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #2b353b;
  color: #e0e6e9;
  display: grid;
  gap: 9px;
  grid-template-columns: 16px minmax(0, 1fr);
  min-height: 44px;
  padding: 7px 10px;
  text-align: left;
  width: 100%;
}

.multiEventoSelectorLista button:hover,
.multiEventoSelectorLista button.ativo {
  background: #29343a;
}

.multiEventoSelectorLista button.selecionado > i {
  color: #42bd89;
}

.multiEventoSelectorLista span,
.multiEventoSelectorLista strong,
.multiEventoSelectorLista small {
  display: block;
  min-width: 0;
}

.multiEventoSelectorLista strong {
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multiEventoSelectorLista small {
  color: #91a0a8;
  font-size: 9px;
  margin-top: 2px;
}

.multiEventoSelectorLista p {
  color: #aab5ba;
  font-size: 10px;
  margin: 0;
  padding: 22px 12px;
  text-align: center;
}
</style>
